import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { VersionComponent } from './version.component';

@NgModule({
	declarations: [VersionComponent],
	imports: [
		CommonModule,
		RouterModule.forChild([
			{
				path: '**',
				component: VersionComponent,
				data: SaveStateData
			}
		])
	]
})
export class VersionModule {}
